import { useRouteMatch } from 'react-router-dom';

import { RoutesHelper } from 'src/common/helpers/RoutesHelper';

export const useDashboardBasePath = (): string => {
	const mobileMatch = useRouteMatch(RoutesHelper.getMobileAccessibilityDashboardPath());
	return mobileMatch
		? RoutesHelper.getMobileAccessibilityDashboardPath()
		: RoutesHelper.getAccessibilityDashboardPath();
};
